<template>
	<figure class="figure">

		<div class="figure-img" v-if="!!$slots.img">
			<slot name="img">
			</slot>
		</div>

		<figcaption class="figcaption" v-if="!!$slots.figcaption">
			<slot name="figcaption">
			</slot>
		</figcaption>

	</figure>
</template>

<script>
export default {
	name: "IFigure",
};
</script>
